export const ERROR_MESSAGE_COPY = {
  error: 'Something Went Wrong',
  report: 'Report',
  reportSubject: '[Bug Report]',
};
